/**
 * Tracker for life insurance sold leads
 * Should be added only when OfferConversion received from trackers endpoint
 * https://seopa01.atlassian.net/browse/SU-4395
 */
export const initOfferConversion = function () {
  const isTrackerDisabled = process.env.NODE_ENV === 'development';
  if (isTrackerDisabled) return;

  const trackerImg = document.createElement('img');
  trackerImg.src = 'https://trk.loudedig.com/aff_l?offer_id=3753';
  trackerImg.width = 1;
  trackerImg.height = 1;
  document.body.appendChild(trackerImg);
};
